import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Calendar, FileText, Menu as MenuIcon, LayoutDashboard, Users, Package, Sparkles, Receipt, UserCheck, Boxes, Settings, CalendarClock, LogOut, Flower2, BarChart3, FileQuestion, ClipboardList, FileBarChart, CreditCard, X, ChevronLeft, LayoutGrid } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => { setIsOpen(false); }, [location.pathname]);

  const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/analytics', icon: BarChart3, label: 'Analytics' },
    { to: '/clients', icon: Users, label: 'Clients' },
    { to: '/menus', icon: MenuIcon, label: 'Menus' },
    { to: '/rentals', icon: Sparkles, label: 'Rentals' },
    { to: '/decor', icon: Flower2, label: 'Decor' },
    { to: '/contracts', icon: FileText, label: 'Contracts' },
    { to: '/standalone-beos', icon: ClipboardList, label: 'Standalone BEOs' },
    { to: '/quote-management', icon: FileQuestion, label: 'Quote Requests' },
    { to: '/invoices', icon: Receipt, label: 'Invoices' },
    { to: '/calendar', icon: Calendar, label: 'Calendar' },
    { to: '/weekly-sheet', icon: CalendarClock, label: 'Weekly Sheet' },
    { to: '/floorplan', icon: LayoutGrid, label: 'Floorplans' },
    { to: '/event-reports', icon: FileBarChart, label: 'Event Reports' },
    { to: '/pos', icon: CreditCard, label: 'Cocktail Coach POS' },
    { to: '/staff', icon: UserCheck, label: 'Staff' },
    { to: '/staff-scheduler', icon: CalendarClock, label: 'Staff Scheduler' },
    { to: '/equipment', icon: Package, label: 'Equipment' },
    { to: '/inventory', icon: Boxes, label: 'Inventory' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <>
      {/* Mobile hamburger */}
      <button onClick={() => setIsOpen(true)} data-testid="mobile-menu-btn"
        className="lg:hidden fixed top-3 left-3 z-40 bg-[#1e3a5f] text-white p-2 rounded-lg shadow-lg print:hidden">
        <MenuIcon size={22} />
      </button>

      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsOpen(false)} />}

      {/* Sidebar */}
      <div className={`
        fixed lg:sticky top-0 left-0 z-50 lg:z-auto
        w-64 bg-gradient-to-b from-[#1e3a5f] to-[#152a45] text-white min-h-screen h-screen
        flex flex-col print:hidden overflow-y-auto
        transition-transform duration-200 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `} data-testid="sidebar">
        <div className="p-6 pb-4 flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-[#c9a227] mb-0.5">Willow Ridge</h1>
            <p className="text-xs text-gray-400">Catering Management</p>
          </div>
          <button onClick={() => setIsOpen(false)} className="lg:hidden text-gray-400 hover:text-white" data-testid="close-sidebar-btn">
            <X size={20} />
          </button>
        </div>
        
        <nav className="space-y-1 flex-1 px-3 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) =>
                `flex items-center space-x-3 px-3 py-2.5 rounded-lg transition-all text-sm ${
                  isActive ? 'bg-[#c9a227] text-[#1e3a5f] font-semibold shadow-lg' : 'text-gray-300 hover:bg-[#2a4a6f] hover:text-white'
                }`
              }>
              <item.icon size={18} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-white/20 p-4 mt-2">
          {user && <div className="mb-2 px-1"><p className="text-xs text-gray-400 truncate">{user.email}</p><p className="text-xs text-[#c9a227]">{user.name}</p></div>}
          <button onClick={logout} className="flex items-center space-x-3 px-3 py-2.5 rounded-lg text-sm text-gray-300 hover:bg-red-600 hover:text-white w-full" data-testid="logout-btn">
            <LogOut size={18} /><span>Sign Out</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
